import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addJobApprovedDoc({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = new FormData();
    //设置富文本的控件为空字符串，否则会崩
    formData['Group'] = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function addFromTemplateByGroup({ parameter, pageComponent } = {}) {
  openAddFromTemplate({ component: pageComponent, group: parameter, groupDisabled: true });
}

// 打开弹框并初始化数据
export function openAddFromTemplate({ component, group = null, groupDisabled = false } = {}) {
  component.setState({ jobApprovedDocAddFromTemplateShow: true });
  let dialog = component.jobApprovedDocAddFromTemplate.current;
  dialog?.setState({ activeKey: 0, groupDisabled: groupDisabled });
  setTimeout(() => {
    dialog?.formRef.current?.resetFields();
    dialog?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], jobApprovedDocTemplatePresetContentList: [] });
    setTimeout(() => {
      dialog?.getJobApprovedDocGroupTemplateDataSource();
      dialog?.getJobApprovedDocTemplatePresetDataSource();
      dialog?.additionalFormRef.current?.child.current?.getJobApprovedDocTemplateData();
      // Group 级别入口预设并锁定分组
      if (group !== null) {
        dialog?.formRef.current?.setFieldValue('Group', group);
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}
